export const ARABIC_REGEX = /^[^<>$"`]+$/;
export const ENGLISH_REGEX = /^[^<>$"`]+$/;
export const USER_TYPES = {
  ADMIN: 1,
  MODERATOR: 2,
  PARTNER: 3,
};
export const USER_TYPES_CATEGORIES = {
  NEWCOMER: 1,
  SERVICE_ONLY: 2,
  SERVICE_MARKETING: 3,
};
export const CLIENTS_CATEGORIES = [
  {
    id: 1,
    name_en: "Newcomer",
  },
  {
    id: 2,
    name_en: "Service Only",
  },
  {
    id: 3,
    name_en: "Service & Marketing",
  },
];
export const BOOLEAN_CHOICES = [
  { id: 1, title: "Yes" },
  { id: 0, title: "No" },
];

export const IS_MARKTER = 3;

export const PARTNERS_DATA_TABS = [
  { key: "all", label: "All Partners" },
  { key: "pv-active", label: "Active" },
  { key: "direct", label: "Directs" },
  { key: "pending", label: "Pending" },
  { key: "uncompleted", label: "Uncompleted" },
];
export const LESSONS_TABS = [
  { key: "live", label: "Live Sessions" },
  { key: "recorded", label: "Recorded Sessions" },
];

export const PACKAGE_CATEGORIES = [
  {
    id: 1,
    title: "Silver Packages",
    key: "Silver",
    color: { from: "#4C4D4E", to: "#B0B1B4" },
  },
  {
    id: 2,
    title: "Gold Packages",
    key: "Gold",
    color: { from: "#C49E07", to: "#FACC15" },
  },
  {
    id: 3,
    title: "Diamond Packages",
    key: "Diamond",
    color: { from: "#048A8A", to: "#10C4C4" },
  },
  {
    id: 4,
    title: "Newcomer",
    color: { from: "#2D8F5F", to: "#3ECF89" },
  },
  {
    id: 5,
    title: "Registration",
    color: { from: "#FF9202", to: "#FFB554" },

    is_active: 1,
    created_by: 1,
  },
];

export const PACKAGE_TYPES = [
  {
    id: 1,
    title: "Fixed",
  },
  {
    id: 2,
    title: "Customized",
  },
];
export const IS_ACTIVE = [
  {
    title: "Active",
    id: 1,
  },
  {
    title: "Inactive",
    id: 0,
  },
];

export const WALLET_HISTORY_TABS = [
  { key: "Action", label: "Action" },
  { key: "create", label: "Creation History" },
  { key: "withdraw", label: "Withdraw History" },
];
export const ACCOUNTS_REVIEW_TABS = [
  { key: "pending", label: "Pending" },
  { key: "needsModification", label: "Needs Modification" },
  { key: "confirmed", label: "Confirmed" },
];
export const ADMIN_PARTNERS_DATA_TABS = [
  { key: "all", label: "All Partners" },
  { key: "pv-active", label: "Active" },
  { key: "pending", label: "Pending" },
  { key: "uncompleted", label: "Uncompleted" },
];
export const ADMIN_DATA_TABS = [
  { key: "pending", label: "Pending" },
  { key: "accepted", label: "Accepted" },
  { key: "rejected", label: "Rejected" },
];
export const MODERATOR_DATA_TABS = [
  { key: "accepted", label: "Accepted" },
  { key: "rejected", label: "Rejected" },
];

export const BreadcrumbItemsForParnters = [
  { title: "Home", link: "/" },
  { title: "Parnters", link: "/parnters" },
];
export const BreadcrumbItemsForAdmins = [
  { title: "Home", link: "/" },
  { title: "Admin", link: "/admin" },
];

export const DEFAULT_TREE_LEVEL = 3;
export const E_MONEY_VALUE = 30;

export const emailRegex = /^\S+@\S+\.\S+$/;

export const CLIENT_ACCOUNT_REVIEW_ID = {
  PENDING: 1,
  CONFIRMED: 2,
  NEED_MODIFICATION: 3,
};

export const CLIENT_SUBSCRIPTION_CATEGORIES = {
  Soon: "soonToExpire",
  extend_one: "firstExtensionPeriod",
  extend_two: "secondExtensionPeriod",
  Expired: "expired",
  re_activate_subscription: "reactivateExpired",
};
export const PV_STATUS = [
  { label: "Pending", id: 1 },
  { label: "Used", id: 2 },
  { label: "Flash Out", id: 3 },
  { label: "Cancelled", id: 4 },
];
export const PV_POSITION = [
  { label: "Left", id: "L" },
  { label: "Right", id: "R" },
];

export const PV_DIRECT_STATUS = [
  { label: "Not Used", id: 0 },
  { label: "Used", id: 1 },
  { label: "Cancelled For Subscription Expiration", id: 2 },
];
export const MESSAGE_TYPES = [
  { label: "Message", id: 0 },
  { label: "Complaint", id: 1 },
];
export const MESSAGE_TYPES_ENUM = { Message: 0, Complaint: 1 };

export const PAYMENT_CHANNELSS = {
  WalletPayment: 1,
  PaymentVerification: 2,
  OnlinePayment: 3,
  OnlinePaymentInstallment: 4,
};
